/* Cart drawer — externalized + deferred 2026-08-19 (was 12KB inline). money_format via #cpg-cart-config JSON block; defines window.cpgOpenCart/cpgCloseCart (callers guard with if(window.cpgOpenCart)). */
(function () {
  var CPG_CART_MONEY_FORMAT = (function(){ try { return JSON.parse((document.getElementById('cpg-cart-config')||{}).textContent); } catch(e){ return '$'+'{{amount}}'; } })();

    if (window.__cpgCartDrawer) return;
    window.__cpgCartDrawer = true;

    var MONEY_FORMAT = CPG_CART_MONEY_FORMAT;
    var root = document.getElementById('cpgCartDrawer');
    if (!root) return;
    var els = {};
    ['items','count','foot','empty','subtotal','total','savings','savings-row','vehicle','vehicle-name','added','added-text','shipbar','shipfill','shipmsg'].forEach(function (k) {
      els[k] = root.querySelector('[data-cd-' + k + ']');
    });

    function money(cents) {
      var val = (Math.round(cents) / 100);
      function fmt(dp, thousands) {
        var n = val.toFixed(dp);
        var parts = n.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return dp ? parts.join('.') : parts[0];
      }
      var out = MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
        switch (name) {
          case 'amount': return fmt(2, ',');
          case 'amount_no_decimals': return fmt(0, ',');
          case 'amount_with_comma_separator': return fmt(2, '.').replace('.', ',');
          case 'amount_no_decimals_with_comma_separator': return fmt(0, '.');
          case 'amount_with_apostrophe_separator': return fmt(2, "'");
          default: return fmt(2, ',');
        }
      });
      return out;
    }

    var isOpen = false;
    function open(fromAdd) {
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      isOpen = true;
      refresh(fromAdd);
    }
    function close() {
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      isOpen = false;
      if (els.added) els.added.hidden = true;
    }
    window.cpgOpenCart = open;
    window.cpgCloseCart = close;

    var lastAddedKey = null;
    function refresh(fromAdd) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart, fromAdd); })
        .catch(function () {});
    }

    function vehicleLabel() {
      try {
        var v = JSON.parse(localStorage.getItem('cpg:garage:vehicle'));
        if (v && v.year && v.make && v.model) return [v.year, v.make, v.model, v.submodel].filter(Boolean).join(' ');
      } catch (e) {}
      return '';
    }

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

    function render(cart, fromAdd) {
      var count = cart.item_count || 0;
      els.count.textContent = count + (count === 1 ? ' item' : ' items');

      var veh = vehicleLabel();
      if (veh && els.vehicle) { els.vehicle.hidden = false; els['vehicle-name'].textContent = veh; }
      else if (els.vehicle) { els.vehicle.hidden = true; }

      if (!count) {
        els.items.innerHTML = '';
        els.items.style.display = 'none';
        els.empty.style.display = 'flex';
        els.foot.hidden = true;
        if (els.added) els.added.hidden = true;
        return;
      }
      els.items.style.display = '';
      els.empty.style.display = 'none';
      els.foot.hidden = false;

      // A core deposit line (added by cpg-core-deposit.js) is never the "just added" item.
      var isCore = function (it) { return !!(it.properties && it.properties._core_for); };
      var lastAdded = cart.items.filter(function (it) { return !isCore(it); })[0] || null;
      var addedKey = fromAdd && lastAdded ? lastAdded.key : null;

      els.items.innerHTML = cart.items.map(function (it) {
        if (isCore(it)) {
          // Deposit follows its part automatically, so it gets no quantity or remove controls.
          return '<div class="cpg-cd__item is-core" data-key="' + esc(it.key) + '">' +
            '<div class="cpg-cd__info">' +
              '<div class="cpg-cd__core-name">Refundable core deposit</div>' +
              '<div class="cpg-cd__core-note">For ' + esc(it.properties.For || '') + (it.quantity > 1 ? ' (x' + it.quantity + ')' : '') + '. Refunded when you return your old part.</div>' +
            '</div>' +
            '<div class="cpg-cd__price"><div class="cpg-cd__price-now">' + money(it.final_line_price) + '</div></div>' +
          '</div>';
        }
        var brand = it.vendor ? '<div class="cpg-cd__brand">' + esc(it.vendor) + '</div>' : '';
        var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') + '" alt="" loading="lazy">' : '';
        var sku = it.sku ? '<div class="cpg-cd__meta">SKU ' + esc(it.sku) + '</div>' : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cpg-cd__meta">' + esc(it.variant_title) + '</div>' : '';
        // "Fits: <vehicle>" line property stamped at add time (honest — only set when
        // the PDP confirmed fit; buyer-override adds are marked and get no checkmark).
        var fitsVal = it.properties && it.properties.Fits ? String(it.properties.Fits) : '';
        var fits = ''; void fitsVal;
        var was = (it.original_line_price > it.final_line_price) ? '<div class="cpg-cd__price-was">' + money(it.original_line_price) + '</div>' : '';
        var isAdded = it.key === addedKey ? ' is-added' : '';
        return '<div class="cpg-cd__item' + isAdded + '" data-key="' + esc(it.key) + '">' +
          '<button type="button" class="cpg-cd__remove" data-cd-remove aria-label="Remove"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
          '<div class="cpg-cd__img">' + img + '</div>' +
          '<div class="cpg-cd__info">' + brand +
            '<a class="cpg-cd__name" href="' + esc(it.url) + '">' + esc(it.product_title || it.title) + '</a>' +
            (sku || variant) + '<div data-ff-slot="' + esc(it.key) + '"></div>' +
            '<div class="cpg-cd__bottom">' +
              '<div class="cpg-cd__qty">' +
                '<button type="button" data-cd-minus aria-label="' + (it.quantity <= 1 ? 'Remove' : 'Decrease') + '">' + (it.quantity <= 1 ? '<svg class="cpg-cd__trash" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>' : '−') + '</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-cd-plus aria-label="Increase">+</button>' +
              '</div>' +
              '<div class="cpg-cd__price"><div class="cpg-cd__price-now">' + money(it.final_line_price) + '</div>' + was + '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');

      runFitFlow();
      els.subtotal.textContent = money(cart.items_subtotal_price);
      if (els.shipbar) {
        var _sub = cart.items_subtotal_price || 0, _thr = 8000, _pct = Math.max(2, Math.min(100, Math.round(_sub / _thr * 100)));
        els.shipfill.style.width = _pct + '%';
        if (_sub >= _thr) { els.shipmsg.innerHTML = 'You have unlocked <strong>free shipping</strong>.'; els.shipbar.classList.add('is-complete'); }
        else { els.shipmsg.innerHTML = 'You are <strong>' + money(_thr - _sub) + '</strong> away from free shipping.'; els.shipbar.classList.remove('is-complete'); }
        els.shipbar.hidden = count === 0;
      }
      var savings = (cart.original_total_price || cart.items_subtotal_price) - cart.total_price;
      // savings = line-item discounts already in items_subtotal vs total; use total_discount
      var totalDisc = cart.total_discount || 0;
      if (totalDisc > 0 && els['savings-row']) { els['savings-row'].hidden = false; els.savings.textContent = '−' + money(totalDisc); }
      else if (els['savings-row']) { els['savings-row'].hidden = true; }
      els.total.textContent = money(cart.total_price);

      if (fromAdd && els.added && lastAdded) {
        els['added-text'].textContent = 'Added: ' + (lastAdded.product_title || lastAdded.title);
        els.added.hidden = false;
        window.clearTimeout(window.__cpgCdAddedTimer);
        window.__cpgCdAddedTimer = window.setTimeout(function () { if (els.added) els.added.hidden = true; }, 3200);
      }
    }

    // ── MOCKUP fit flow: vehicle bar, per-line fit badge, note above checkout, proof stamping ──
    var ffSeq = 0, ffStampedOnce = false;
    function runFitFlow() {
      if (!window.CPGFitFlow) return;
      var F = window.CPGFitFlow, seq = ++ffSeq;
      F.checkCart().then(function (res) {
        if (seq !== ffSeq) return;
        var anyNeeds = Object.keys(res.lines).some(function (k) { var s = res.lines[k].status; return s !== 'universal' && s !== 'spec'; });
        var bar = root.querySelector('[data-ff-vehbar]'); if (bar) bar.innerHTML = F.vehicleBarHtml(res.vehicle, anyNeeds);
        Object.keys(res.lines).forEach(function (k) {
          var slot = root.querySelector('[data-ff-slot="' + (window.CSS && CSS.escape ? CSS.escape(k) : k) + '"]');
          if (slot) slot.innerHTML = F.badgeHtml(res.lines[k], { key: k });
        });
        var note = root.querySelector('[data-ff-note]'); if (note) note.innerHTML = F.noteHtml(res);
        F.stamp(res).then(function (changed) { if (changed && !ffStampedOnce) { ffStampedOnce = true; refresh(false); } else { ffStampedOnce = false; } });
      }).catch(function () {});
    }
    window.addEventListener('cpg:vehicle-changed', function () { if (isOpen) refresh(false); });
    document.addEventListener('cpg:fitflow-cart-changed', function () { refresh(false); document.dispatchEvent(new CustomEvent('cart:refresh')); });

    // ── qty + remove ──
    function changeLine(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        render(cart, false);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(function () {});
    }
    root.addEventListener('click', function (e) {
      var row = e.target.closest ? e.target.closest('.cpg-cd__item') : null;
      if (e.target.closest && e.target.closest('[data-cd-close]')) { close(); return; }
      if (!row) return;
      var key = row.getAttribute('data-key');
      var qtyEl = row.querySelector('.cpg-cd__qty span');
      var q = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (e.target.closest('[data-cd-plus]')) changeLine(key, q + 1);
      else if (e.target.closest('[data-cd-minus]')) changeLine(key, q - 1);
      else if (e.target.closest('[data-cd-remove]')) changeLine(key, 0);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });
    // The core deposit sync changed the cart behind the drawer: redraw it.
    document.addEventListener('cpg:core-synced', function () { if (isOpen) refresh(false); });

    // ── react to the THEME's native cart popup ──────────────────────────────
    // The base theme already AJAX-adds and opens its own <aside.cp-cart-popup>.
    // We suppress that popup (CSS hides it) and, on the same signal, show THIS
    // designed drawer. Reusing the theme's add avoids any double-add risk.
    function neutralizeNative(pop) {
      var overlay = document.querySelector('.cp-cart-overlay');
      var wasOpen = pop.classList.contains('is-open') || (overlay && overlay.classList.contains('is-open'));
      if (!wasOpen) return;
      pop.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      // the theme locks body scroll — release it (our drawer locks <html> itself)
      try { document.body.style.overflow = ''; } catch (e) {}
      // If our drawer is already open (e.g. header-icon click opened it), this is
      // NOT a fresh add — just refresh. Otherwise it's an add → open with flash.
      if (isOpen) refresh(false);
      else open(true);
    }
    function watchNative() {
      var pop = document.querySelector('.cp-cart-popup');
      if (pop) {
        new MutationObserver(function () { neutralizeNative(pop); }).observe(pop, { attributes: true, attributeFilter: ['class'] });
        neutralizeNative(pop); // catch an already-open one
      }
      // The popup may be (re)injected — watch the header for it appearing.
      var host = document.getElementById('header') || document.body;
      new MutationObserver(function () {
        var p2 = document.querySelector('.cp-cart-popup');
        if (p2 && !p2.__cpgWatched) {
          p2.__cpgWatched = true;
          new MutationObserver(function () { neutralizeNative(p2); }).observe(p2, { attributes: true, attributeFilter: ['class'] });
          neutralizeNative(p2);
        }
      }).observe(host, { childList: true, subtree: true });
    }
    if (document.readyState !== 'loading') watchNative();
    else document.addEventListener('DOMContentLoaded', watchNative);

    // Add-to-cart → open the drawer. The base theme's native popup (which watchNative piggybacks on)
    // is fully suppressed and never fires 'is-open', so that fast path is dead; without this, the drawer
    // only appeared via a poll AFTER /cart/add finished (~1-1.5s), which read as "nothing happened on
    // the first click". So: open the drawer IMMEDIATELY on a valid add click (instant feedback showing
    // the current cart), then poll /cart.js and refresh(true) once the new line lands (~0.5s) to show it
    // with the "Added" flash. Reads only — never adds, so no double-add.
    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest ? e.target.closest('[name="add"], [data-cpg-sticky-add]') : null;
      if (!addBtn || addBtn.closest('#cpgCartDrawer')) return;
      // Skip disabled / non-add buttons (out of stock, contact-for-availability) so we don't open on a
      // click that will not add anything.
      if (addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') return;
      var act = addBtn.getAttribute('data-cpg-stock-action');
      if (act && act !== 'add-to-cart') return;
      if (!isOpen) open(false); else refresh(false);
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c0) {
          var start = c0.item_count, tries = 0;
          (function poll() {
            tries++;
            fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (c) {
                if (c.item_count > start) { refresh(true); }
                else if (tries < 12) window.setTimeout(poll, 200);
              }).catch(function () {});
          })();
        }).catch(function () {});
    }, false);

    // Header cart icon → open THIS drawer (theme may also open its popup; the
    // watcher above suppresses that and, since we're already open, won't reflash).
    document.addEventListener('click', function (e) {
      var trg = e.target.closest ? e.target.closest('[data-cp-cart-open], a[href$="/cart"], a[href*="/cart?"]') : null;
      if (!trg) return;
      // The drawer's OWN "View full cart" link is also an a[href="/cart"]; it must NAVIGATE to the
      // full cart page, not be swallowed by this header-icon "open the drawer" handler (that was the
      // bug — clicking View full cart just re-opened the drawer and looked dead).
      if (trg.closest('#cpgCartDrawer')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      open(false);
    }, false);
  })();
